export const DOCUSIGN_SIGN_COMPLETE = 'signing_complete';
